import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.Dropdown
      @propertyName='transplantedOrgan'
      @labelName='Type de greffe'
      @translationKey='pathology.transplanted-organ'
      as |dropdown|
    >
      <dropdown.Item @key='heart' />
      <dropdown.Item @key='heart-lung' />
      <dropdown.Item @key='heart-kidney' />
      <dropdown.Item @key='heart-kidney-liver' />
      <dropdown.Item @key='heart-lung-kidney' />
      <dropdown.Item @key='' @value='Non renseigné' />
    </@form.Dropdown>
  </div>

  <div class='two fields' data-test-transplant-date-section>
    <div class='field'>
      <@form.Date
        @labelName='Date de la greffe'
        @propertyName='transplantDate'
      />
    </div>
    <div class='field'>
      <label>
        Rang de la greffe
      </label>
      <div class='four unstackable fields'>
        <@form.BasicRadioGroup @propertyName='transplantRank' as |Group|>
          <Group.FieldRadio @label='1' @value='1' />
          <Group.FieldRadio @label='2' @value='2' />
        </@form.BasicRadioGroup>
      </div>
    </div>
  </div>

  <div class='field'>
    <@form.Dropdown
      @labelName='Cardiopathie'
      @propertyName='underlyingDisease'
      @translationKey='pathology.underlying-disease'
      @allowAdditions={{true}}
      as |dropdown|
    >
      <dropdown.Item @key='congenital-heart-defects' />
      <dropdown.Item @key='cardiomyopathy' />
      <dropdown.Item @key='myocardial-infarction' />
      <dropdown.Item @key='high-blood-pressure' />
      <dropdown.Item @key='valve-anomaly' />
      <dropdown.Item @key='drug-cardiotoxicity' />
      <dropdown.Item @key='heart-rhythm-disorders' />
      <dropdown.Item @key='other' />
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
